import { Component } from 'react';
import { fromJS } from 'immutable';
import { FormattedMessage } from 'react-intl';

// COMPONENTS
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import { FilterFormContainer, FilterFormTitle, ButtonsContainer, FilterItemGroup, RadioContainer } from './styles';

// CONSTANTS
import { FILTER_FORM } from 'constants/filters';
import { ifInTestingMode } from 'utils/tests.utils';

class ConnectivityConfiguration extends Component {
  state = {
    option: FILTER_FORM.connectivity[0],
  };

  getFormItems = () =>
    FILTER_FORM.connectivity.map((item) => (
      <FilterItemGroup
        key={`connectivity-filter-${item.translation}`}
        data-testid={ifInTestingMode(`filter__${item.translation}`)}
      >
        <RadioContainer>
          <RadioButton
            renderedValue={{
              translationId: `components.Filters.${item.translation}`,
            }}
            // @ts-expect-error TS(2769): No overload matches this call.
            selected={item.translation === this.state.option.translation}
            onClick={this.handleChangeOption(item)}
          />
        </RadioContainer>
      </FilterItemGroup>
    ));

  handleChangeOption = (option) => () => {
    this.setState({ option });
  };

  handleSaveFilter = () => {
    let value = null;

    if (this.state.option.translation === 'isConnected') {
      value = '1';
    } else if (this.state.option.translation === 'isDisconnected') {
      value = '0';
    }

    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(
      fromJS({
        comparator: this.state.option.comparator,
        // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
        field: this.props.column.get('name'),
        value,
      })
    );
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        {this.getFormItems()}

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid={ifInTestingMode('filters__apply')} onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

export default ConnectivityConfiguration;
